/** Invoice line description for postage rows. */
export function buildPostageInvoiceLineDescription({
  serviceCode,
  jobNo,
  tranMonth,
  tranYear,
} = {}) {
  const code = String(serviceCode ?? "").trim();
  const jacket = String(jobNo ?? "").trim();
  const month = String(tranMonth ?? "").trim();
  const year = String(tranYear ?? "").trim();
  const period = month && year ? `${month}/${year}` : year || month;
  const parts = [];
  if (code) {
    parts.push(code);
  }
  parts.push("Postage");
  if (jacket) {
    parts.push(jacket);
  }
  if (period) {
    parts.push(period);
  }
  return parts.join(" ").trim();
}
